import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link } from 'react-router-dom'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import "../includes/react-quill-custom-stylesheet.css"
import { Tooltip } from "antd";

import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";
import PageLoader from "../common_component/PageLoader.js";
import { useHistory } from 'react-router-dom';

function ConfigureEcommerceItemInfo(props) {
    const [state, setstate] = useState(2);
    const history = useHistory();

    const [failedPageMessage, setFailedPageMessage] = useState("Something went wrong. Please reload this page.")
    const [subcategorySpecification, setSubcategorySpecification] = useState([])
    const [productName, setProductName] = useState("")

    const [ecommerceProductDisplayName, setEcommerceProductDisplayName] = useState("")
    const [ecommerceModelNumber, setEcommerceModelNumber] = useState("")
    const [shortDetails, setShortDetails] = useState("")
    const [productDescription, setProductDescription] = useState("")
    const [productSpecificationData, setProductSpecificationData] = useState([])
    const [highlights, setHighlights] = useState("")
    const [richContent, setRichContent] = useState("")

    const [submitButtonState, setSubmitButtonState] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false)

    var page_name = "configure-ecommerce-item-info";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    const quill_rte_modules = {
        toolbar: [
            [{ 'font': [] }, { 'size': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'script': 'super' }, { 'script': 'sub' }],
            [{ 'header': '1' }, { 'header': '2' }, 'blockquote', 'code-block'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['direction', { 'align': [] }],
            ['link', 'image', 'video', 'formula'],
            ['clean']
        ],
    }
    const quill_rte_formats = ["header", "font", "size", "bold", "italic", "underline", "align", "strike", "script", "blockquote", "background", "list", "bullet", "indent", "link", "image", "color", "code-block"]

    async function getProductEcommerceInfo(pid) {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-product-ecommerce-info`, { method: 'POST', body: JSON.stringify({ "email": user.email, "product_id": pid, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)

        if (body.operation == "success") {
            setProductName(body.data.product_name)

            if (body.data.ecommerce_info) {
                setEcommerceProductDisplayName(body.data.ecommerce_info.ecommerce_product_display_name || "")
                setEcommerceModelNumber(body.data.ecommerce_info.ecommerce_model_number || "")
                setShortDetails(body.data.ecommerce_info.short_details || "")
                setProductDescription(body.data.ecommerce_info.product_description || "")
                const cleanedData = (body.data.ecommerce_info.product_specification_data || []).map(spec => ({
                    heading: spec.heading?.trim() || "",
                    attribute_list: (spec.attribute_list || []).map(attr => ({
                        attribute: attr.attribute?.trim() || "",
                        value: attr.value?.trim() || ""
                    }))
                }));

                setProductSpecificationData(cleanedData);
                setHighlights(body.data.ecommerce_info.highlights || "")
                setRichContent(body.data.ecommerce_info.rich_content || "")
            } else {
                setEcommerceProductDisplayName(body.data.product_name)
            }
        }
        else {
            throw body.message
        }
    }
    async function getSubcategorySpecificationByProduct(pid) {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-subcategory-specification-by-product`, { method: 'POST', body: JSON.stringify({ "email": user.email, "product_id": pid, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)

        if (body.operation == "success") {
            if (body.data) {
                setSubcategorySpecification(body.data.specification_data)
            }
        }
        else {
            throw body.message
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            let p1 = getProductEcommerceInfo(props.match.params.id)

            Promise.all([p1])
                .then(async () => {
                    await getSubcategorySpecificationByProduct(props.match.params.id)

                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    setFailedPageMessage(err)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    useEffect(() => {
        // console.log(subcategorySpecification, productSpecificationData)
        let t1 = productSpecificationData.map(x => { return { ...x } })

        subcategorySpecification.forEach((x) => {
            let t = productSpecificationData.find(a => a.heading.toLowerCase() == x.heading.toLowerCase())
            if (t == undefined) {
                t1.push({ heading: x.heading, attribute_list: x.attribute_list.map(a => { return { attribute: a, value: "" } }) })
            }
            else {
                let t2 = x.attribute_list.filter((y) => !t.attribute_list.find(b => b.attribute.toLowerCase() == y.toLowerCase()))
                let t1o = t1.find(c => c.heading.toLowerCase() == x.heading.toLowerCase())
                t2.forEach(d => {
                    t1o.attribute_list.push({ attribute: d, value: "" })
                })
            }
        })

        setProductSpecificationData(t1)

    }, [subcategorySpecification])


    const configureProductEcommerceInfoSubmit = () => {

        if (ecommerceProductDisplayName == "") {
            swal("Oops!", "Product Display Name cannot be empty", "warning")
            return
        }
        if (shortDetails == "") {
            swal("Oops!", "Short Details cannot be empty", "warning")
            return
        }
        if (productDescription == "") {
            swal("Oops!", "Product Description cannot be empty", "warning")
            return
        }
        if (highlights == "") {
            swal("Oops!", "Highlights cannot be empty", "warning")
            return
        }

        let flag = false;
        let headingSet = new Set();
        let headingDuplicate = false;
        let attributeDuplicate = false;
        let trimmedHeadings = [];
        let headingAttrMap = {};

        productSpecificationData.forEach((obj, i) => {
            obj.heading = obj.heading.trim();
            trimmedHeadings.push(obj.heading);

            if (obj.heading === "") {
                flag = true;
            }

            // Check for duplicate headings
            if (headingSet.has(obj.heading)) {
                headingDuplicate = true;
            } else {
                headingSet.add(obj.heading);
            }

            if (!headingAttrMap[obj.heading]) {
                headingAttrMap[obj.heading] = new Set();
            }

            obj.attribute_list.forEach(attr => {
                attr.attribute = attr.attribute.trim();
                attr.value = attr.value.trim();

                if (attr.attribute === "" || attr.value === "") {
                    flag = true;
                }

                // Check for duplicate attribute in same heading
                if (headingAttrMap[obj.heading].has(attr.attribute)) {
                    attributeDuplicate = true;
                } else {
                    headingAttrMap[obj.heading].add(attr.attribute);
                }
            });
        });

        if (flag) {
            swal("Oops!", "Product Specification Data cannot have empty fields", "warning");
            return;
        }

        if (headingDuplicate) {
            swal("Oops!", "Two headings cannot be the same.", "warning");
            return;
        }

        if (attributeDuplicate) {
            swal("Oops!", "Two attributes under the same heading cannot be the same.", "warning");
            return;
        }

        var object = {};

        object.ecommerce_product_display_name = ecommerceProductDisplayName
        object.ecommerce_model_number = ecommerceModelNumber
        object.short_details = shortDetails
        object.product_description = productDescription
        object.product_specification_data = productSpecificationData
        object.highlights = highlights
        object.rich_content = richContent
        object.product_id = props.match.params.id

        object.organization_id = organization_id;
        object.page_name = page_name;

        setSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/configure-product-ecommerce-info`, object, headers).then((res) => {
            setSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", "Product Ecommerce Info configured successfully!", "success").then(() => { history.go(0) })
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    async function generateEcommerceItemInfo() {
        if (!productName.trim()) {
            swal("Oops!", "Product Name cannot be empty for generating details", "warning")
            return
        }
        if (!ecommerceModelNumber.trim()) {
            swal("Oops!", "Model Number cannot be empty for generating details", "warning")
            return
        }

        const payload = JSON.stringify({
            "product_name": productName.trim(),
            "model_number": ecommerceModelNumber.trim(),

            "email": user.email,
            "page_name": page_name,
            "organization_id": organization_id
        })

        setIsGenerating(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/generate-ecommerce-item-info`, { method: 'POST', body: payload, headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        setIsGenerating(false)

        if (body.operation == "success") {
            console.log(body);

            setShortDetails(body.data.shortDetails)
            setProductDescription(body.data.productDescription)
            setHighlights(body.data.highlights)
            setRichContent(body.data.richContent)
        }
        else {
            swal("Oops!", body.data.message, "error")
        }
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Configure E-Commerce Item info</h1>
                    <div className="d-flex align-items-center gap-3">
                        <Tooltip title="SpotERP Docs" >
                            <a
                                href={`${process.env.REACT_APP_SPOTERP_DOCS}/ecommerce/item#5-configure-product-ecommerce-info`}
                                className='btn btn-light-primary py-2 px-3'
                                target="_blank"
                            >
                                <i className="bi bi-journal-text fs-1 px-0"></i>
                            </a>
                        </Tooltip>
                        {productName != "" && <span><span className="fw-bold">Item:- </span><span className='text-info'>{productName}</span></span>}
                    </div>
                </div>
                <div>
                    {
                        state == 1 ?
                            <>
                                <div className="card my-2">
                                    <div className="card-header"><div className='card-title fw-bold required'>Basic Details</div></div>
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col-xl-5 mb-5 mb-xl-0'>
                                                <label className="required fs-5 fw-bold mb-2">Ecommerce Product Display Name</label>
                                                <input type="text" className="form-control form-control-solid" value={ecommerceProductDisplayName} onChange={(e) => { setEcommerceProductDisplayName(e.target.value) }} placeholder='Product Display Name' />
                                            </div>
                                            <div className='col-xl-5 mb-5 mb-xl-0'>
                                                <label className="fs-5 fw-bold mb-2">Ecommerce Model Number</label>
                                                <input type="text" className="form-control form-control-solid" value={ecommerceModelNumber} onChange={(e) => { setEcommerceModelNumber(e.target.value) }} placeholder='Model Number' />
                                            </div>
                                            <div className='col-xl-2 align-self-xl-end'>
                                                <button className="h-glass-rainbow-btn" disabled={isGenerating} onClick={() => { generateEcommerceItemInfo() }}>
                                                    {isGenerating && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                                                    {
                                                        isGenerating ? ' Loading...' : <>
                                                            <i className="bi bi-stars"></i>
                                                            AI Generate
                                                        </>
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card my-2">
                                    <div className="card-header">
                                        <div className='card-title fw-bold required'>Short Details</div>
                                    </div>
                                    <div className="card-body">
                                        <ReactQuill
                                            theme="snow"
                                            modules={quill_rte_modules}
                                            formats={quill_rte_formats}
                                            value={shortDetails}
                                            onChange={(val) => { setShortDetails(val) }}
                                        />
                                    </div>
                                </div>

                                <div className="card my-2">
                                    <div className="card-header"><div className='card-title fw-bold required'>Product Description</div></div>
                                    <div className="card-body">
                                        <ReactQuill
                                            theme="snow"
                                            modules={quill_rte_modules}
                                            formats={quill_rte_formats}
                                            value={productDescription}
                                            onChange={(val) => { setProductDescription(val) }}
                                        />
                                    </div>
                                </div>

                                <div className="card my-2">
                                    <div className="card-header"><div className='card-title fw-bold required'>Product Specification</div></div>
                                    <div className="card-body">
                                        <div className='container'>
                                            {
                                                productSpecificationData.length == 0 ? <div className='text-center'><div className='text-gray-600 fs-2'>No Headers added</div></div> :
                                                    productSpecificationData.map((obj, i) => {
                                                        return (
                                                            <div key={i}>
                                                                <div className='d-flex'>
                                                                    <label className='form-label my-auto mx-2'>Heading</label>
                                                                    <input className="form-control form-control-solid m-1 mb-2" placeholder="Enter a Heading..." value={obj.heading}
                                                                        onChange={(e) => {
                                                                            let t = productSpecificationData.map(x => { return { ...x } })
                                                                            t[i].heading = e.target.value
                                                                            setProductSpecificationData(t)
                                                                        }}
                                                                    />
                                                                    <button className='btn btn-link text-hover-danger mx-3'
                                                                        onClick={() => {
                                                                            let t = productSpecificationData.map(x => { return { ...x } })
                                                                            t.splice(i, 1)
                                                                            setProductSpecificationData(t)
                                                                        }}
                                                                    >&#10006;</button>
                                                                </div>
                                                                {
                                                                    obj.attribute_list.map((obj2, j) => {
                                                                        return (
                                                                            <div key={j} className='d-flex ms-10'>
                                                                                <label className='form-label my-auto mx-2'>Attribute</label>
                                                                                <input className="form-control form-control-solid m-1" placeholder="Enter an Attribute..." value={obj2.attribute}
                                                                                    onChange={(e) => {
                                                                                        let t = productSpecificationData.map(x => { return { ...x } })
                                                                                        t[i].attribute_list[j].attribute = e.target.value
                                                                                        setProductSpecificationData(t)
                                                                                    }}
                                                                                />
                                                                                <input className="form-control form-control-solid m-1" placeholder="Enter Value..." value={obj2.value}
                                                                                    onChange={(e) => {
                                                                                        let t = productSpecificationData.map(x => { return { ...x } })
                                                                                        t[i].attribute_list[j].value = e.target.value
                                                                                        setProductSpecificationData(t)
                                                                                    }}
                                                                                />
                                                                                <button className='btn btn-link text-hover-danger mx-3'
                                                                                    onClick={() => {
                                                                                        let t = productSpecificationData.map(x => { return { ...x } })
                                                                                        t[i].attribute_list.splice(j, 1)
                                                                                        setProductSpecificationData(t)
                                                                                    }}
                                                                                >&#10006;</button>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                                <button className='btn btn-link text-hover-success ms-10'
                                                                    onClick={() => {
                                                                        let t = productSpecificationData.map(x => { return { ...x } })
                                                                        t[i].attribute_list.push({ attribute: "", value: "" })
                                                                        setProductSpecificationData(t)
                                                                    }}>+ Add Attribute
                                                                </button>
                                                            </div>
                                                        )
                                                    })
                                            }
                                            <button className='btn btn-link text-hover-success' onClick={() => { setProductSpecificationData([...productSpecificationData, { heading: "", attribute_list: [] }]) }}>+ Add Heading</button>
                                        </div>
                                    </div>
                                </div>

                                <div className="card my-2">
                                    <div className="card-header"><div className='card-title fw-bold required'>Highlights</div></div>
                                    <div className="card-body">
                                        <ReactQuill
                                            theme="snow"
                                            modules={quill_rte_modules}
                                            formats={quill_rte_formats}
                                            value={highlights}
                                            onChange={(val) => { setHighlights(val) }}
                                        />
                                    </div>
                                </div>

                                <div className="card my-2">
                                    <div className="card-header"><div className='card-title fw-bold'>Rich Content</div></div>
                                    <div className="card-body">
                                        <ReactQuill
                                            theme="snow"
                                            modules={quill_rte_modules}
                                            formats={quill_rte_formats}
                                            value={richContent}
                                            onChange={(val) => { setRichContent(val) }}
                                        />
                                    </div>
                                </div>

                                {
                                    write &&
                                    <button type="button" className="btn btn-sm btn-info m-3 " data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={() => { configureProductEcommerceInfoSubmit() }}>
                                        <span className="indicator-label">Save</span>
                                        <span className="indicator-progress">Please wait...
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </span>
                                    </button>
                                }
                            </>
                            :
                            state == 2 ?
                                <PageLoader />
                                :
                                <PageError message={failedPageMessage}>
                                    <Link to={`/subcategory-list`} className="btn btn-sm btn-primary me-3 rounded cursor-pointer">Go to Subcategory List</Link>
                                </PageError>
                    }
                </div>
            </div>
        </>
    );
}
export default ConfigureEcommerceItemInfo;